/**
 * Pre-compiled en messages for DraggableList
 * Generated by @internationalized/string-compiler
 * DO NOT EDIT MANUALLY
 */

export default {
  emptyMessage: `drop items here`,
  removeButtonLabel: `remove item`,
};
